import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface HoursUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}
export const hoursUpdated = createAction<HoursUpdatedPayload>('HOURS_UPDATED');
